import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DateAdapter, MAT_DATE_FORMATS, NativeDateAdapter } from '@angular/material/core';

export interface VerifySetPopupData {
  setName: string;
  verifiedByName?: string;
  verifiedDate?: Date | string | null;
  verificationNotes?: string | null;
  cardsCheckedConfirmed?: boolean;
}

const VERIFY_SET_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY'
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: { month: 'short', year: 'numeric' },
    dateA11yLabel: { day: '2-digit', month: '2-digit', year: 'numeric' },
    monthYearA11yLabel: { month: 'long', year: 'numeric' }
  }
};

class VerifySetDateAdapter extends NativeDateAdapter {
  override format(date: Date, _displayFormat: object): string {
    if (!date) {
      return '';
    }

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
}

@Component({
  selector: 'app-verify-set-popup',
  standalone: false,
  templateUrl: './verify-set-popup.html',
  styleUrls: ['./verify-set-popup.scss'],
  providers: [
    { provide: DateAdapter, useClass: VerifySetDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: VERIFY_SET_DATE_FORMATS }
  ]
})
export class VerifySetPopup {
  setName: string;
  verifiedDate: Date = new Date();
  verifiedByName: string = '';
  verificationNotes: string = '';
  cardsCheckedConfirmed: boolean = false;
  maxDate: Date = new Date();
  readonly verifierNameMaxLength = 255;
  readonly notesMaxLength = 1000;

  constructor(
    private readonly dialogRef: MatDialogRef<VerifySetPopup>,
    @Inject(MAT_DIALOG_DATA) public data: VerifySetPopupData
  ) {
    this.setName = data?.setName || '';
    this.verifiedByName = data?.verifiedByName?.trim() || '';

    if (data?.verifiedDate) {
      const parsedDate = data.verifiedDate instanceof Date ? data.verifiedDate : new Date(data.verifiedDate);
      if (!isNaN(parsedDate.getTime())) {
        this.verifiedDate = parsedDate;
      }
    }

    if (data?.verificationNotes !== undefined && data?.verificationNotes !== null) {
      this.verificationNotes = data.verificationNotes;
    }

    if (data?.cardsCheckedConfirmed !== undefined && data?.cardsCheckedConfirmed !== null) {
      this.cardsCheckedConfirmed = !!data.cardsCheckedConfirmed;
    }
  }

  get canConfirm(): boolean {
    return !!this.verifiedDate && !!this.verifiedByName?.trim();
  }

  close(): void {
    this.dialogRef.close({ confirm: false });
  }

  confirmVerification(): void {
    if (!this.canConfirm) {
      return;
    }

    this.dialogRef.close({
      confirm: true,
      verifiedDate: this.verifiedDate,
      verifiedByName: this.verifiedByName.trim().slice(0, this.verifierNameMaxLength),
      verificationNotes: (this.verificationNotes?.trim() || '').slice(0, this.notesMaxLength),
      cardsCheckedConfirmed: !!this.cardsCheckedConfirmed
    });
  }
}
